









































































import { Component, Vue } from "vue-property-decorator";
import MovingDetail from "@/components/contract-moving/movingDetail.vue";
import User, { USER_ROLE } from "@/model/user";
import { namespace } from "vuex-class";
import Company from "@/model/company";
import QUserSelect from "@/common/qUserSelect.vue";
import ContractMoveOut from "@/model/contractMoveOut";
import qNotify from "@/common/qNotify";
import QErrors from "@/common/qErrors.vue";

const auth = namespace("Auth");
const moveOutStore = namespace("MoveOut");
const routerStore = namespace("Router");
@Component({
  name: "StepApplicationAcceptance",
  components: {
    MovingDetail,
    QUserSelect,
    QErrors,
  },
})
export default class StepApplicationAcceptance extends Vue {
  @auth.Getter
  getCurrentyCompany!: Company;
  @auth.Getter
  getUserLogging!: User;
  @moveOutStore.Getter
  getMoveOut!: ContractMoveOut;
  @routerStore.Getter
  public getSearchParameters!:any;

  public moveOutObject: ContractMoveOut = new ContractMoveOut();

  public userRole = USER_ROLE;
  public showPopup = false;
  public errors = {};

  mounted() {
    this.moveOutObject = new ContractMoveOut(this.getMoveOut);
    this.moveOutObject.accepted_by = this.getUserLogging.id;
  }

  get companyId() {
    return this.getCurrentyCompany.id;
  }

  public reject() {
    this.$modal.showCancel({
      title: "申請を却下します",
      text: "退去申請を却下します。",
      confirmText: "却下",
      cancelText: "キャンセル",
      confirmClass: "mb__button mb__w-100pc mb__add-color-red",
      cancelClass: "mb__button mb__w-100pc mb__add-color-gray",
      type: "",
      // we are passing callback method for our confirm button
      onConfirm: async () => {
        // this.$router.back();
        const result = await this.moveOutObject.reject();
        if (result.meta.status === 200) {
          this.$router.push({ name: "admin.contract-moving" , query: this.getSearchParameters ? this.getSearchParameters.contractMovingList : null });
        } else {
          qNotify.error({
            text: result.meta.message,
          });
        }
      },
    });
  }

  public cancel() {
    if (this.moveOutObject.accepted_by === this.getUserLogging.id) {
      this.$router.push({ name: "admin.contract-moving" , query: this.getSearchParameters ? this.getSearchParameters.contractMovingList : null });
    } else {
      this.$modal.showCancel({
        text: this.$t("cancel"),
        // we are passing callback method for our confirm button
        onConfirm: () => {
          this.$router.push({ name: "admin.contract-moving" , query: this.getSearchParameters ? this.getSearchParameters.contractMovingList : null });
        },
      });
    }
  }

  public async submit() {
    const result = await Promise.all([
      this.moveOutObject.accept(),
      this.moveOutObject.updateMoveOutDate(),
    ])
    if (result[0].meta.status === 200 && result[1].meta.status === 200) {
      this.showPopup = true;
    } else {
      qNotify.error({
        text: result[0].meta.message,
      });
      this.errors = result[0].meta.errors;
    }
  }

  public next() {
    this.$router.replace({ query: { step: "next" } });
    this.showPopup = false;
  }

  moveOut (moveOut: any) {
    this.moveOutObject.moving_out_date = moveOut.moving_out_date
  }
}
